import React from 'react';
import { type EngagedStatus } from '@bbkAdminRedux/rtkq/reports.slice';
import { cs } from '@bbkAdminUtils/css-utils';
import { type EnumLike } from '@bbkAdminUtils/utility-types';

export const EngagedStatusPill: React.FC<{
  status: EnumLike<typeof EngagedStatus>;
}> = ({ status }) => (
  <div
    className={cs(
      'tw-mr-2 tw-h-3 tw-w-3 tw-rounded-full tw-bg-cbrprimary-500',
      {
        'tw-bg-cbrsuccess-300': status === 'ACCEPTED',
        'tw-bg-cbrdanger-300': status === 'REJECTED',
      }
    )}
  />
);
